import { generateId } from "@msuite/utils/strings";
import { useEffect, useState } from "react";

export function useIdle(timeout: number) {
	/** State */
	const [idle, setIdle] = useState(false);
	const [sessionId, setSessionId] = useState(generateId());

	/** Effects */
	useEffect(() => {
		let timer: ReturnType<typeof setTimeout>;

		function onActivity() {
			setIdle(false);
			clearTimeout(timer);
			timer = setTimeout(() => setIdle(true), timeout);
		}

		window.addEventListener("mousemove", onActivity);
		window.addEventListener("keypress", onActivity);

		return () => {
			window.removeEventListener("mousemove", onActivity);
			window.removeEventListener("keypress", onActivity);
			clearTimeout(timer);
		};
	}, [timeout]);

	useEffect(() => {
		const id = generateId();
		setSessionId(id);
	}, [idle]);

	/** Return */
	return { idle, sessionId };
}
